import {FC, useEffect, useState} from 'react'
import clsx from 'clsx'
import {useLocation, useNavigate} from 'react-router-dom'
import {KTIcon} from '../../../../helpers'
import {useLayout} from '../../../core'
import {SidebarMenuItem} from './SidebarMenuItem'

/**
 * Email Management sidebar entry:
 * - First click (outside section) → landing `/email-management`
 * - Click again while already in Email Management → toggle Transactional / Marketing dropdown
 */
const SidebarMenuEmailManagement: FC = () => {
  const {pathname} = useLocation()
  const navigate = useNavigate()
  const {config} = useLayout()
  const {app} = config

  const inSection = pathname === '/email-management' || pathname.startsWith('/email-management/')
  const onLanding = pathname === '/email-management'
  const onChild =
    pathname.startsWith('/email-management/transactional') ||
    pathname.startsWith('/email-management/marketing')

  // Open dropdown when on a child page; closed on first landing visit until user toggles.
  const [open, setOpen] = useState(onChild)

  useEffect(() => {
    if (onChild) setOpen(true)
  }, [onChild])

  const onParentClick = () => {
    if (!inSection) {
      navigate('/email-management')
      setOpen(false)
      return
    }
    // Already in Email Management → second click toggles side dropdown
    setOpen((v) => !v)
    if (!onLanding && !onChild) {
      navigate('/email-management')
    }
  }

  return (
    <div
      className={clsx('menu-item', {'here show': open || onChild}, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span
        className={clsx('menu-link', {active: inSection})}
        role='button'
        tabIndex={0}
        onClick={onParentClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onParentClick()
          }
        }}
      >
        {app?.sidebar?.default?.menu?.iconType === 'svg' ? (
          <span className='menu-icon'>
            <KTIcon iconName='sms' className={clsx('fs-2', {'text-primary': inSection})} />
          </span>
        ) : (
          <i className='bi bi-envelope fs-3'></i>
        )}
        <span className='menu-title'>
          Email Management
          <span className='badge badge-light-success ms-2 fs-9'>NEW</span>
        </span>
        <span className='menu-arrow'></span>
      </span>
      <div
        className={clsx('menu-sub menu-sub-accordion', {
          'menu-active-bg': open,
          show: open,
        })}
        style={{display: open ? undefined : 'none'}}
      >
        <SidebarMenuItem to='/email-management/transactional' title='Transactional Emails' hasBullet />
        <SidebarMenuItem to='/email-management/marketing' title='Marketing Emails' hasBullet />
      </div>
    </div>
  )
}

export {SidebarMenuEmailManagement}
